 
import '../static/form.css';
import React, { useState, useEffect  } from "react";
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import HistoryGromming from '../components/HistoryGromming';

const IndexForm = () => {
    const [formData, setFormData] = useState({
        name: '',
        ownername: '',
        phone: '',
      });
  const [responseMessage ,setResponseMessage] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [selectedPetId, setSelectedPetId] = useState(null);
  const navigate = useNavigate(); // React Router hook for navigation

    
  
  // Function to fetch pet names for autocomplete
  const fetchSuggestions = async (query) => {
    try {
      const response = await fetch(`/autocomplete-pet-names/?query=${query}`);
      const data = await response.json();
      setSuggestions(data.suggestions || []);
    } catch (error) {
      console.error('Error fetching pet names:', error);
    }
  };


  // Fetch autocomplete suggestions when the name input changes
  const handleNameChange = async (e) => {
    const { value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      name: value,
    }));
    if (value.length > 2) {
        fetchSuggestions(value);
      } else {
        setSuggestions([]); // Clear suggestions if input is short
      }
    };
  
  const handleSuggestionClick = (suggestion) => {
    setFormData((prevState) => ({
      ...prevState,
      name: suggestion.name,
      ownername: suggestion.owner,
      phone: suggestion.phone,
    }));
    setSelectedPetId(suggestion.id); // Store the selected pet ID
    setSuggestions([]); // Clear suggestions after selecting one
  };

    // Handle change in other input fields (e.g., owner's name)
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
        ...prevData,
        [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
      
        const { name, phone} = formData;
      
        try {
          // Construct the query string with form data
          const queryParams = new URLSearchParams({
            name,
               // Assuming ownername is the name of the owner
            phone ,
          }).toString();
      
          // Perform the GET request to the backend API
          const response = await fetch(`/fetch-pet/?${queryParams}`);
          const data = await response.json();
      
          // Handle the response from the backend
          if (response.ok) {
            navigate(`/history-groom/?name=${data.name}&catdog=${data.catdog}&owner=${data.ownername}&image=${data.image}&phone=${data.phone}&breed=${data.breed}&age=${data.age}&behaviour=${data.behaviour}
              &allergies=${data.allergies}&vaccinated=${data.vaccinated}&grooming_history=${data.grooming_history}
              &booking_date=${data.booking_date}&extra_info=${data.extra_info}&text=${data.text}`); 
          } else {
            setResponseMessage('Pet not found.');
          }
        } catch (error) {
          console.error('Error fetching pet:', error);
          setResponseMessage('An error occurred. Please try again.');
        }
      };
      
  
    return (
      <section className="contact-wrap">
        <form className="contact-form" onSubmit={handleSubmit}>
        <label>Name of Pet</label>
          <div className="input-block">
            
            <input type="text" name="name" value={formData.name} onChange={handleNameChange}  className="form-control" />
            {suggestions.length > 0 && (
            <ul className="autocomplete-suggestions">
              {suggestions.map((suggestion) => (
                <li key={suggestion.id} onClick={() => handleSuggestionClick(suggestion)}>
                   {suggestion.name} 
                </li>
              ))}
            </ul>
          )}
          
          </div>
           
       <label>Name of Owner</label>
       <div className="input-block">
          <input type="text" name="ownername"  value={formData.ownername} onChange={handleChange} className="form-control" />
        </div>
        <label>Telephone Number</label>
       <div className="input-block">
          <input type="text" name="phone"  value={formData.phone} onChange={handleChange} className="form-control" />
        </div>    
          <div className=" ">
            <button type="submit" className="square-button">Find Out</button>
          </div>
        </form>
  
        {responseMessage && <p className="response-message">{responseMessage}</p>}
      </section>
    );
  };
  
export default IndexForm;

  